import { useState, useEffect } from 'react';
import useWakeLock from './wakeLock';
import '../scss/InstructionsHeader.scss';

function InstructionsHeader({ sectionsState, setSectionsState, inView }) {

  // Instructions display settings (affect all sections)
  const [cookMode, setCookMode] = useState(false);
  const [showPhotos, setShowPhotos] = useState(true);
  const [showTimers, setShowTimers] = useState(true);
  const [showAmounts, setShowAmounts] = useState(true);
  const [boldIngredients, setBoldIngredients] = useState(true);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    setCookMode(inView)
  }, [inView])

  const wakeLock = useWakeLock(cookMode);

  // expand/collapse all sections
  function toggleAllSections() {
    setSectionsState(
      sectionsState.map(section => {
        // if at least 1 section is collapsed, button will be "Expand all"
        if (sectionsState.some(section => section.isCollapsed)) {
          return { ...section, isCollapsed: false };
        // otherwise, if all are expanded, button will be "Collapse all"
        } else {
          return { ...section, isCollapsed: true };
        }
      })
    )
  }

  return (
    <header 
      id="instructions-header" 
      className="section-header"
      data-cook-mode={cookMode}
      data-show-photos={showPhotos}
      data-show-timers={showTimers}
      data-show-amounts={showAmounts}
      data-bold-ingredients={boldIngredients}
      data-all-expanded={!sectionsState.some(section => section.isCollapsed)}
    >
      <h2>Instructions</h2>
      {/* Settings menu */}
      <div id="instructions-settings">
        <button 
          onClick={() => setShowMenu(!showMenu)} 
          className="modal-trigger icon"
          title="Settings menu"
        ></button>
        <div className="modal-wrapper" data-show-menu={showMenu}>
          <div className="modal-overlay" onClick={() => setShowMenu(!showMenu)}></div>
          <div className="modal-content">
            {/* Cook mode */}
            <div id="cook-mode-setting">
              <header
                data-checked={cookMode}
                onClick={() => setCookMode(prevCookMode => !prevCookMode)}
              >
                <h3>Cook mode</h3>
                <div className="toggle" data-checked={cookMode}>
                  <div className="toggle-inner"></div>
                </div>
              </header>
              <p>Cook mode keeps the screen from going to sleep while you’re cooking, and makes the instructions steps selectable so it’s easier to keep track of where you are.</p>
            </div>
            <h3>Other display settings</h3>
            {/* Photos */}
            <li>
              <input 
                type="checkbox" 
                id="show-photos-checkbox" 
                checked={showPhotos}
                onChange={e => setShowPhotos(e.target.checked)} 
              />
              <label htmlFor="show-photos-checkbox" title="Show instructional photos">Show photos</label>
            </li>
            {/* Timers */}
            <li>
              <input 
                type="checkbox" 
                id="show-timers-checkbox" 
                checked={showTimers}
                onChange={e => setShowTimers(e.target.checked)} 
              />
              <label htmlFor="show-timers-checkbox" title="Show interactive timers within the instructions (for times over 5 minutes)">Show interactive timers</label>
            </li>
            {/* Amounts */}
            <li>
              <input 
                type="checkbox" 
                id="show-amounts-checkbox" 
                checked={showAmounts}
                onChange={e => setShowAmounts(e.target.checked)} 
              />
              <label htmlFor="show-amounts-checkbox" title="Show ingreient amounts inline wherever an ingredient is mentioned in the instructions">Show ingredient amounts</label>
            </li>
            {/* Bold ingredients */}
            <li>
              <input 
                type="checkbox" 
                id="bold-ingredients-checkbox" 
                checked={boldIngredients}
                onChange={e => setBoldIngredients(e.target.checked)} 
              />
              <label htmlFor="bold-ingredients-checkbox" title="Show ingredients in bold text">Bold ingredients</label>
            </li>
          </div>
        </div>
      </div>
      {/* Expand/collapse all sections */}
      {/* only show if there are multiple sections */}
      {sectionsState.length > 1 && 
        <button 
        onClick={toggleAllSections} 
        className={"icon expand-collapse"}
        title={sectionsState.some(section => section.isCollapsed) ? "Expand all sections" : "Collapse all sections"}
        ></button>
      }
    </header>
  );
}

export default InstructionsHeader;
